export default "__VITE_ASSET__9d9d64c1__"